import { FC } from "react";
import CustomPopup from "../../../../custom-components/CustomPopup";
import { useTranslation } from "react-i18next";

interface EditApplicationSuccessProps {
    isEditSuccessPopupVisible: boolean;
    setEditSuccessPopupVisible: (value: boolean) => void;
}

const EditApplicationSuccess: FC<EditApplicationSuccessProps> = (props) => {
    const { t } = useTranslation();

    return (
        <CustomPopup
            isVisible={props.isEditSuccessPopupVisible}
            setIsVisible={props.setEditSuccessPopupVisible}
            wrapClassName="dmin2:min-w-[628px] di6:min-w-[428px] ti6:min-w-[428px] ti7:min-w-[340px] tmax4:min-w-[340px] border border-backgroundButton"
            confirmTitle={t("common.ok")}
            confirmHandler={() => props.setEditSuccessPopupVisible(false)}
            confirmButtonClassName="w-[193px] dmax2:w-[133px] h-[50px] dmax2:h-[40px] mt-8 dmax2:mt-6"
        >
            <p className="H20 dmax2:H16 text-textWhite text-center mt-[10px] dmin2:max-w-[420px] di6:max-w-[320px] ti6:max-w-[320px] ti7:max-w-[280px] tmax4:max-w-[280px]">
                {t("work.applicationEditionSuccess")}
            </p>
        </CustomPopup>
    );
};

export default EditApplicationSuccess;
